import { defaultAlarmColors } from '../../components/alarms/helpers';
import { AlarmAcknowledgementActions, AlarmColorType, AlarmDetailsExpandedState, AlarmModel, AlarmNote, AlarmNoteForAcknowledge } from '../../model/AlarmModel';
import { AlarmAction } from './actions';
import { AlarmActionType } from './actionsTypes';

export type AlarmState = {
	showAlarmDetails: boolean;
	alarmModel: Partial<AlarmModel>;
	showAlarmDetailsExpandedState: AlarmDetailsExpandedState;
	showAddOperatorNote: boolean;
	alarmNoteForAcknowledge: AlarmNoteForAcknowledge;
	operatorNoteAdded: AlarmNote[];
	showCredentials: boolean;
	credentialsIds: number[];
	alarmColors: Record<AlarmColorType, string>;
};

//States' definition
const INIT_STATE: AlarmState = {
	alarmModel: undefined,
	showAlarmDetails: false,
	showAlarmDetailsExpandedState: AlarmDetailsExpandedState.None,
	showAddOperatorNote: false,
	alarmNoteForAcknowledge: {
		acknowledgeAction: AlarmAcknowledgementActions.None,
		alarms: [],
		isAlarmNoteForAcknowledge: false,
	},
	operatorNoteAdded: [],
	showCredentials: false,
	credentialsIds: [],
	alarmColors: defaultAlarmColors,
};

//Reducers
const alarmReducer = (state: Readonly<AlarmState> = INIT_STATE, action: AlarmAction): AlarmState => {
	switch (action.type) {
		case AlarmActionType.SET_SHOW_ALARM_DETAILS: {
			const { payload } = action;

			return {
				...state,
				alarmModel: payload?.alarmModel,
				showAlarmDetails: payload !== undefined,
				showAlarmDetailsExpandedState: payload?.showAlarmDetailsExpandedState ?? AlarmDetailsExpandedState.None,
			};
		}

		case AlarmActionType.SET_SHOW_ALARM_CREDENTIALS: {
			const { payload } = action;

			return {
				...state,
				showCredentials: payload.showCredentials,
				credentialsIds: payload.credentialsIds,
			};
		}

		case AlarmActionType.SET_SHOW_ALARM_ADD_OPERATOR_NOTE: {
			return {
				...state,
				showAddOperatorNote: action.payload,
			};
		}

		case AlarmActionType.SET_ALARM_NOTE_FOR_ACKNOWLEDGE: {
			return {
				...state,
				alarmNoteForAcknowledge: {
					...state.alarmNoteForAcknowledge,
					...action.payload,
				},
			};
		}

		case AlarmActionType.SET_OPERATOR_NOTES_ADDED: {
			return {
				...state,
				operatorNoteAdded: action.payload,
			};
		}

		case AlarmActionType.SET_ALARM_COLORS: {
			return {
				...state,
				alarmColors: action.payload,
			};
		}

		default:
			return state;
	}
};

export { alarmReducer };
